export const respFake: any = {
  data: {
    page: {
      groupsPaginated: {
        totalPages: 2,
        limit: 10,
        page: 1,
        total: 18,
        data: [
          {
            name: null,
            description: null,
            padding: 0,
            vtex_query: null,
            round_shape: false,
            action_text: null,
            redirect_value: null,
            redirect_type: null,
            size: null,
            type: null,
            guidance_type: null,
            is_full_width_banner: null,
            width: null,
            height: null,
            padding_right: 0,
            padding_left: 0,
            padding_top: 0,
            padding_bottom: 0,
            border_color: null,
            border_top: 0,
            border_bottom: 0,
            border_left: 0,
            border_right: 0,
            background_color: null,
            horizontal_padding: 0,
            vertical_padding: 0,
            reference_id: null,
            gap: 2,
            rounded_size: 0,
            product: null,
            products: [],
            display: {
              slug: 'carrossel-de-stories',
              __typename: 'ElementDisplay',
            },
            items: [
              {
                id: '56d2d738-dfaf-4627-8e44-7f5ee2c08b45',
                name: 'Supermercado',
                countdown: false,
                padding: 0,
                filter_data: null,
                schedule_end: null,
                schedule_start: '2024-10-01T18:46:43.762Z',
                redirect_type: 'query',
                redirect_value: 'supermercado?map=c',
                modal: null,
                has_modal: false,
                text_color: null,
                weight: null,
                width: null,
                facets: '',
                image_description: null,
                highlighted: false,
                image_align: null,
                redirect_data: null,
                highlighted_color: null,
                file: {
                  url: 'https://d150vhkc2dyuy0.cloudfront.net/superxtra-staging/1727808403310-default--supermercado.png',
                  __typename: 'Upload',
                },
                reference_value: '',
                __typename: 'GroupElement',
              },
              {
                id: '2966161c-b655-4531-8bb4-2bec0b6354fa',
                name: 'Licor, cerveza y vino',
                countdown: false,
                padding: 0,
                filter_data: null,
                schedule_end: null,
                schedule_start: '2024-10-01T18:48:04.736Z',
                redirect_type: 'query',
                redirect_value: 'licor-cerveza-y-vino?map=c',
                modal: null,
                has_modal: false,
                text_color: null,
                weight: null,
                width: null,
                facets: '',
                image_description: null,
                highlighted: false,
                image_align: null,
                redirect_data: null,
                highlighted_color: null,
                file: {
                  url: 'https://d150vhkc2dyuy0.cloudfront.net/superxtra-staging/1727808484318-default--licor--cerveza-y-vino.png',
                  __typename: 'Upload',
                },
                reference_value: '',
                __typename: 'GroupElement',
              },
              {
                id: 'd6c45fc9-23df-4fc8-a45c-fcdaf0f02363',
                name: 'Cuidado personal',
                countdown: false,
                padding: 0,
                filter_data: null,
                schedule_end: null,
                schedule_start: '2024-10-01T18:50:45.537Z',
                redirect_type: 'query',
                redirect_value: 'cuidado-personal-y-belleza?map=c',
                modal: null,
                has_modal: false,
                text_color: null,
                weight: null,
                width: null,
                facets: '',
                image_description: null,
                highlighted: false,
                image_align: null,
                redirect_data: null,
                highlighted_color: null,
                file: {
                  url: 'https://d150vhkc2dyuy0.cloudfront.net/superxtra-staging/1727808645058-default--cuidado-personal-y-belleza.png',
                  __typename: 'Upload',
                },
                reference_value: '',
                __typename: 'GroupElement',
              },
              {
                id: '69cf9ce7-1f66-407b-960f-a19706d89db7',
                name: 'Limpieza',
                countdown: false,
                padding: 0,
                filter_data: null,
                schedule_end: null,
                schedule_start: '2024-10-01T18:51:26.250Z',
                redirect_type: 'query',
                redirect_value: 'limpieza-del-hogar-y-ropa?map=c',
                modal: null,
                has_modal: false,
                text_color: null,
                weight: null,
                width: null,
                facets: '',
                image_description: null,
                highlighted: false,
                image_align: null,
                redirect_data: null,
                highlighted_color: null,
                file: {
                  url: 'https://d150vhkc2dyuy0.cloudfront.net/superxtra-staging/1727809241114-default--limpieza-del-hogar-y-ropa.png',
                  __typename: 'Upload',
                },
                reference_value: '',
                __typename: 'GroupElement',
              },
              {
                id: '12f30deb-d0ec-433c-9196-7a4a6757bb7e',
                name: 'Mascotas',
                countdown: false,
                padding: 0,
                filter_data: null,
                schedule_end: null,
                schedule_start: '2024-10-01T18:51:55.173Z',
                redirect_type: 'query',
                redirect_value: 'mascotas?map=c',
                modal: null,
                has_modal: false,
                text_color: null,
                weight: null,
                width: null,
                facets: '',
                image_description: null,
                highlighted: false,
                image_align: null,
                redirect_data: null,
                highlighted_color: null,
                file: {
                  url: 'https://d150vhkc2dyuy0.cloudfront.net/superxtra-staging/1727808714721-default--mascotas.png',
                  __typename: 'Upload',
                },
                reference_value: '',
                __typename: 'GroupElement',
              },
              {
                id: 'f86123ff-0ead-44ed-98dc-f6693ab3d262',
                name: 'Bebes',
                countdown: false,
                padding: 0,
                filter_data: null,
                schedule_end: null,
                schedule_start: '2024-10-01T18:53:07.483Z',
                redirect_type: 'query',
                redirect_value: 'bebes?map=c',
                modal: null,
                has_modal: false,
                text_color: null,
                weight: null,
                width: null,
                facets: '',
                image_description: null,
                highlighted: false,
                image_align: null,
                redirect_data: null,
                highlighted_color: null,
                file: {
                  url: 'https://d150vhkc2dyuy0.cloudfront.net/superxtra-staging/1727808787019-default--bebes.png',
                  __typename: 'Upload',
                },
                reference_value: '',
                __typename: 'GroupElement',
              },
              {
                id: '3c629a34-c401-434a-8ac3-abf264797402',
                name: 'Linea blanca y electrodomésticos',
                countdown: false,
                padding: 0,
                filter_data: null,
                schedule_end: null,
                schedule_start: '2024-10-01T18:53:49.167Z',
                redirect_type: 'query',
                redirect_value: 'linea-blanca-y-electrodomesticos?map=c',
                modal: null,
                has_modal: false,
                text_color: null,
                weight: null,
                width: null,
                facets: '',
                image_description: null,
                highlighted: false,
                image_align: null,
                redirect_data: null,
                highlighted_color: null,
                file: {
                  url: 'https://d150vhkc2dyuy0.cloudfront.net/superxtra-staging/1727808828700-default--linea-blanca-y-electrodomesticos.png',
                  __typename: 'Upload',
                },
                reference_value: '',
                __typename: 'GroupElement',
              },
              {
                id: 'fac36cf9-bebc-436e-818f-86c68c0d8061',
                name: 'Hogar, jardin y ferreteria',
                countdown: false,
                padding: 0,
                filter_data: null,
                schedule_end: null,
                schedule_start: '2024-10-01T18:55:50.821Z',
                redirect_type: 'query',
                redirect_value: 'hogar-jardin-y-ferreteria?map=c',
                modal: null,
                has_modal: false,
                text_color: null,
                weight: null,
                width: null,
                facets: '',
                image_description: null,
                highlighted: false,
                image_align: null,
                redirect_data: null,
                highlighted_color: null,
                file: {
                  url: 'https://d150vhkc2dyuy0.cloudfront.net/superxtra-staging/1727808950397-default--hogar--jardin-y-ferreteria.png',
                  __typename: 'Upload',
                },
                reference_value: '',
                __typename: 'GroupElement',
              },
              {
                id: 'b030856c-042c-49e2-89d4-44351e436bfa',
                name: 'Jugueteria, recreation y deportes',
                countdown: false,
                padding: 0,
                filter_data: null,
                schedule_end: null,
                schedule_start: '2024-10-01T18:56:40.648Z',
                redirect_type: 'query',
                redirect_value: 'jugueteria-recreacion-y-deportes?map=c',
                modal: null,
                has_modal: false,
                text_color: null,
                weight: null,
                width: null,
                facets: '',
                image_description: null,
                highlighted: false,
                image_align: null,
                redirect_data: null,
                highlighted_color: null,
                file: {
                  url: 'https://d150vhkc2dyuy0.cloudfront.net/superxtra-staging/1727809000205-default--jugueteria--recreacion-y-deportes.png',
                  __typename: 'Upload',
                },
                reference_value: '',
                __typename: 'GroupElement',
              },
              {
                id: 'a94680fb-fd57-456e-b35c-58223c213e7b',
                name: 'Xtra farmácia',
                countdown: false,
                padding: 0,
                filter_data: null,
                schedule_end: null,
                schedule_start: '2024-10-01T18:57:20.614Z',
                redirect_type: 'query',
                redirect_value: 'xtra-farmacia?map=c',
                modal: null,
                has_modal: false,
                text_color: null,
                weight: null,
                width: null,
                facets: '',
                image_description: null,
                highlighted: false,
                image_align: null,
                redirect_data: null,
                highlighted_color: null,
                file: {
                  url: 'https://d150vhkc2dyuy0.cloudfront.net/superxtra-staging/1727809040188-default--xtra-farmacia.png',
                  __typename: 'Upload',
                },
                reference_value: '',
                __typename: 'GroupElement',
              },
              {
                id: '60458812-605e-4ce9-ba80-b9e3f54fdb51',
                name: 'Escolar y oficina',
                countdown: false,
                padding: 0,
                filter_data: null,
                schedule_end: null,
                schedule_start: '2024-10-01T18:57:53.929Z',
                redirect_type: 'query',
                redirect_value: 'escolar-y-oficina?map=c',
                modal: null,
                has_modal: false,
                text_color: null,
                weight: null,
                width: null,
                facets: '',
                image_description: null,
                highlighted: false,
                image_align: null,
                redirect_data: null,
                highlighted_color: null,
                file: {
                  url: 'https://d150vhkc2dyuy0.cloudfront.net/superxtra-staging/1727809073487-default--escolar-y-oficina.png',
                  __typename: 'Upload',
                },
                reference_value: '',
                __typename: 'GroupElement',
              },
              {
                id: 'c18b8469-5005-47f6-9037-2e3b0f5148c7',
                name: 'Chef café',
                countdown: false,
                padding: 0,
                filter_data: null,
                schedule_end: null,
                schedule_start: '2024-10-01T18:58:34.189Z',
                redirect_type: 'query',
                redirect_value: 'chef-cafe?map=c',
                modal: null,
                has_modal: false,
                text_color: null,
                weight: null,
                width: null,
                facets: '',
                image_description: null,
                highlighted: false,
                image_align: null,
                redirect_data: null,
                highlighted_color: null,
                file: {
                  url: 'https://d150vhkc2dyuy0.cloudfront.net/superxtra-staging/1727809113756-default--chef-cafe.png',
                  __typename: 'Upload',
                },
                reference_value: '',
                __typename: 'GroupElement',
              },
            ],
            __typename: 'PageGroup',
          },
          {
            name: 'banner regressiva',
            description: 'sub banner regressiva',
            padding: 0,
            vtex_query: null,
            round_shape: false,
            action_text: null,
            redirect_value: null,
            redirect_type: null,
            size: null,
            type: null,
            guidance_type: null,
            is_full_width_banner: null,
            width: '150',
            height: '120',
            padding_right: 0,
            padding_left: 0,
            padding_top: 0,
            padding_bottom: 0,
            border_color: null,
            border_top: 0,
            border_bottom: 0,
            border_left: 0,
            border_right: 0,
            background_color: null,
            horizontal_padding: 0,
            vertical_padding: 0,
            reference_id: null,
            gap: 2,
            rounded_size: 0,
            product: null,
            products: [],
            display: {
              slug: 'banner-unico-com-contagem-regressiva',
              __typename: 'ElementDisplay',
            },
            items: [
              {
                id: 'a3bd2f55-d2e5-416d-b2a7-ccf3ef9f4f34',
                name: 'banner regressiva nome',
                countdown: false,
                padding: 0,
                filter_data: null,
                schedule_end: null,
                schedule_start: '2024-10-07T14:22:27.262Z',
                redirect_type: 'product',
                redirect_value: 'adasdasd',
                modal: null,
                has_modal: false,
                text_color: null,
                weight: null,
                width: null,
                facets: null,
                image_description: null,
                highlighted: false,
                image_align: null,
                redirect_data: null,
                highlighted_color: null,
                file: {
                  url: 'https://d150vhkc2dyuy0.cloudfront.net/superxtra-staging/1728310946772-default--xtra.gif',
                  __typename: 'Upload',
                },
                reference_value: null,
                __typename: 'GroupElement',
              },
            ],
            __typename: 'PageGroup',
          },
          {
            name: null,
            description: null,
            padding: 0,
            vtex_query: null,
            round_shape: false,
            action_text: null,
            redirect_value: null,
            redirect_type: null,
            size: null,
            type: null,
            guidance_type: null,
            is_full_width_banner: null,
            width: null,
            height: null,
            padding_right: 0,
            padding_left: 0,
            padding_top: 0,
            padding_bottom: 0,
            border_color: null,
            border_top: 0,
            border_bottom: 0,
            border_left: 0,
            border_right: 0,
            background_color: null,
            horizontal_padding: 0,
            vertical_padding: 0,
            reference_id: null,
            gap: 2,
            rounded_size: 0,
            product: null,
            products: [],
            display: {
              slug: 'carrossel-de-produtos-com-query',
              __typename: 'ElementDisplay',
            },
            items: [
              {
                id: '6231e011-2ad2-45cd-84e7-e478208a25bc',
                name: 'nome query 1',
                countdown: false,
                padding: 0,
                filter_data: null,
                schedule_end: null,
                schedule_start: '2024-10-07T20:10:18.664Z',
                redirect_type: 'query',
                redirect_value: 'query redirect',
                modal: null,
                has_modal: false,
                text_color: null,
                weight: null,
                width: null,
                facets: 'asd',
                image_description: null,
                highlighted: false,
                image_align: null,
                redirect_data: null,
                highlighted_color: null,
                file: null,
                reference_value: null,
                __typename: 'GroupElement',
              },
            ],
            __typename: 'PageGroup',
          },
          {
            name: 'PROMOS FULLXTRA',
            description: null,
            padding: 0,
            vtex_query: null,
            round_shape: false,
            action_text: null,
            redirect_value: null,
            redirect_type: null,
            size: null,
            type: null,
            guidance_type: null,
            is_full_width_banner: null,
            width: null,
            height: null,
            padding_right: 0,
            padding_left: 0,
            padding_top: 0,
            padding_bottom: 0,
            border_color: null,
            border_top: 0,
            border_bottom: 0,
            border_left: 0,
            border_right: 0,
            background_color: null,
            horizontal_padding: 0,
            vertical_padding: 0,
            reference_id: null,
            gap: 2,
            rounded_size: 0,
            product: null,
            products: [],
            display: {
              slug: 'texto-de-foco',
              __typename: 'ElementDisplay',
            },
            items: [],
            __typename: 'PageGroup',
          },
          {
            name: 'FullXtra',
            description: null,
            padding: 0,
            vtex_query: null,
            round_shape: false,
            action_text: null,
            redirect_value: null,
            redirect_type: null,
            size: null,
            type: null,
            guidance_type: null,
            is_full_width_banner: null,
            width: null,
            height: null,
            padding_right: 0,
            padding_left: 0,
            padding_top: 0,
            padding_bottom: 0,
            border_color: null,
            border_top: 0,
            border_bottom: 0,
            border_left: 0,
            border_right: 0,
            background_color: null,
            horizontal_padding: 0,
            vertical_padding: 0,
            reference_id: null,
            gap: 2,
            rounded_size: 0,
            product: null,
            products: [
              {
                productId: '4135',
                productName: 'Leche De Coco Nhs 400 Ml Lata',
                categories: [
                  '/Supermercado/Lácteos, Quesos y refrigerados/Leches enlatadas/',
                  '/Supermercado/Lácteos, Quesos y refrigerados/',
                  '/Supermercado/',
                ],
                productClusters: [
                  ['174', 'Todos los Productos'],
                  ['296', 'TODOS LOS PRODUCTOS'],
                ],
                clusterHighlights: [],
                brand: 'Nhs',
                linkText: 'leche-de-coco-nhs-400-ml-lata',
                skuSpecifications: null,
                items: [
                  {
                    itemId: '4136',
                    name: 'Leche De Coco Nhs 400 Ml Lata',
                    nameComplete: 'Leche De Coco Nhs 400 Ml Lata',
                    variationsValues: [],
                    variations: null,
                    images: [
                      {
                        imageUrl:
                          'https://superxtrapanama.vteximg.com.br/arquivos/ids/160663/4847227365101.png?v=637806418044070000',
                        __typename: 'ItemImage',
                      },
                    ],
                    sellers: [
                      {
                        sellerName: 'Super Xtra',
                        sellerDefault: true,
                        sellerId: '1',
                        commertialOffer: {
                          ListPrice: 1.97,
                          Price: 1.97,
                          Teasers: [],
                          Installments: [
                            {
                              Value: 1.97,
                              NumberOfInstallments: 1,
                              TotalValuePlusInterestRate: 1.97,
                              PaymentSystemName: 'Visa',
                              PaymentSystemGroupName: 'creditCardPaymentGroup',
                              __typename: 'CommertialOfferInstallment',
                            },
                            {
                              Value: 1.97,
                              NumberOfInstallments: 1,
                              TotalValuePlusInterestRate: 1.97,
                              PaymentSystemName: 'Mastercard',
                              PaymentSystemGroupName: 'creditCardPaymentGroup',
                              __typename: 'CommertialOfferInstallment',
                            },
                            {
                              Value: 1.97,
                              NumberOfInstallments: 1,
                              TotalValuePlusInterestRate: 1.97,
                              PaymentSystemName: 'Contra Entrega Efectivo',
                              PaymentSystemGroupName:
                                'custom201PaymentGroupPaymentGroup',
                              __typename: 'CommertialOfferInstallment',
                            },
                            {
                              Value: 1.97,
                              NumberOfInstallments: 1,
                              TotalValuePlusInterestRate: 1.97,
                              PaymentSystemName:
                                'Contra Entrega Tarjeta de Debito',
                              PaymentSystemGroupName:
                                'custom203PaymentGroupPaymentGroup',
                              __typename: 'CommertialOfferInstallment',
                            },
                            {
                              Value: 1.97,
                              NumberOfInstallments: 1,
                              TotalValuePlusInterestRate: 1.97,
                              PaymentSystemName:
                                'Contra Entrega Tarjeta de Credito',
                              PaymentSystemGroupName:
                                'custom204PaymentGroupPaymentGroup',
                              __typename: 'CommertialOfferInstallment',
                            },
                            {
                              Value: 1.97,
                              NumberOfInstallments: 1,
                              TotalValuePlusInterestRate: 1.97,
                              PaymentSystemName: 'Contra Entrega Tarjeta Clave',
                              PaymentSystemGroupName:
                                'custom205PaymentGroupPaymentGroup',
                              __typename: 'CommertialOfferInstallment',
                            },
                          ],
                          AvailableQuantity: 99999,
                          IsAvailable: true,
                          __typename: 'SellerCommertialOffer',
                        },
                        __typename: 'ItemSeller',
                      },
                    ],
                    __typename: 'ProductItem',
                  },
                ],
                __typename: 'ProductDTO',
              },
              {
                productId: '28721',
                productName: 'Patitas De Cerdo First Choice  Xtra KG',
                categories: [
                  '/Supermercado/Carnes y Aves/Cerdo/',
                  '/Supermercado/Carnes y Aves/',
                  '/Supermercado/',
                ],
                productClusters: [
                  ['174', 'Todos los Productos'],
                  ['296', 'TODOS LOS PRODUCTOS'],
                ],
                clusterHighlights: [],
                brand: 'Xtra',
                linkText: 'patitas-de-cerdo-first-choice-xtra-kg-7451072404853',
                skuSpecifications: null,
                items: [
                  {
                    itemId: '10583253',
                    name: 'Patitas De Cerdo First Choice  Xtra KG',
                    nameComplete: 'Patitas De Cerdo First Choice  Xtra KG',
                    variationsValues: [],
                    variations: null,
                    images: [
                      {
                        imageUrl:
                          'https://superxtrapanama.vteximg.com.br/arquivos/ids/192724/7451072404853.png?v=638597795525200000',
                        __typename: 'ItemImage',
                      },
                    ],
                    sellers: [
                      {
                        sellerName: 'Super Xtra',
                        sellerDefault: true,
                        sellerId: '1',
                        commertialOffer: {
                          ListPrice: 12.8,
                          Price: 12.8,
                          Teasers: [],
                          Installments: [
                            {
                              Value: 12.8,
                              NumberOfInstallments: 1,
                              TotalValuePlusInterestRate: 12.8,
                              PaymentSystemName: 'Visa',
                              PaymentSystemGroupName: 'creditCardPaymentGroup',
                              __typename: 'CommertialOfferInstallment',
                            },
                            {
                              Value: 12.8,
                              NumberOfInstallments: 1,
                              TotalValuePlusInterestRate: 12.8,
                              PaymentSystemName: 'Mastercard',
                              PaymentSystemGroupName: 'creditCardPaymentGroup',
                              __typename: 'CommertialOfferInstallment',
                            },
                            {
                              Value: 12.8,
                              NumberOfInstallments: 1,
                              TotalValuePlusInterestRate: 12.8,
                              PaymentSystemName: 'Contra Entrega Efectivo',
                              PaymentSystemGroupName:
                                'custom201PaymentGroupPaymentGroup',
                              __typename: 'CommertialOfferInstallment',
                            },
                            {
                              Value: 12.8,
                              NumberOfInstallments: 1,
                              TotalValuePlusInterestRate: 12.8,
                              PaymentSystemName:
                                'Contra Entrega Tarjeta de Debito',
                              PaymentSystemGroupName:
                                'custom203PaymentGroupPaymentGroup',
                              __typename: 'CommertialOfferInstallment',
                            },
                            {
                              Value: 12.8,
                              NumberOfInstallments: 1,
                              TotalValuePlusInterestRate: 12.8,
                              PaymentSystemName:
                                'Contra Entrega Tarjeta de Credito',
                              PaymentSystemGroupName:
                                'custom204PaymentGroupPaymentGroup',
                              __typename: 'CommertialOfferInstallment',
                            },
                            {
                              Value: 12.8,
                              NumberOfInstallments: 1,
                              TotalValuePlusInterestRate: 12.8,
                              PaymentSystemName: 'Contra Entrega Tarjeta Clave',
                              PaymentSystemGroupName:
                                'custom205PaymentGroupPaymentGroup',
                              __typename: 'CommertialOfferInstallment',
                            },
                          ],
                          AvailableQuantity: 100,
                          IsAvailable: true,
                          __typename: 'SellerCommertialOffer',
                        },
                        __typename: 'ItemSeller',
                      },
                    ],
                    __typename: 'ProductItem',
                  },
                ],
                __typename: 'ProductDTO',
              },
              {
                productId: '7502',
                productName: 'Pasitas Por Media Libra',
                categories: [
                  '/Supermercado/Frutas y Verduras/Frutas Frescas/',
                  '/Supermercado/Frutas y Verduras/',
                  '/Supermercado/',
                ],
                productClusters: [
                  ['174', 'Todos los Productos'],
                  ['296', 'TODOS LOS PRODUCTOS'],
                ],
                clusterHighlights: [],
                brand: 'Frutas',
                linkText: 'pasitas-por-libra',
                skuSpecifications: null,
                items: [
                  {
                    itemId: '7503',
                    name: 'Pasitas Por Media Libra',
                    nameComplete: 'Pasitas Por Media Libra',
                    variationsValues: [],
                    variations: null,
                    images: [
                      {
                        imageUrl:
                          'https://superxtrapanama.vteximg.com.br/arquivos/ids/162489/2701094000003.png?v=637896281242700000',
                        __typename: 'ItemImage',
                      },
                    ],
                    sellers: [
                      {
                        sellerName: 'Super Xtra',
                        sellerDefault: true,
                        sellerId: '1',
                        commertialOffer: {
                          ListPrice: 3.37,
                          Price: 3.37,
                          Teasers: [],
                          Installments: [
                            {
                              Value: 3.37,
                              NumberOfInstallments: 1,
                              TotalValuePlusInterestRate: 3.37,
                              PaymentSystemName: 'Visa',
                              PaymentSystemGroupName: 'creditCardPaymentGroup',
                              __typename: 'CommertialOfferInstallment',
                            },
                            {
                              Value: 3.37,
                              NumberOfInstallments: 1,
                              TotalValuePlusInterestRate: 3.37,
                              PaymentSystemName: 'Mastercard',
                              PaymentSystemGroupName: 'creditCardPaymentGroup',
                              __typename: 'CommertialOfferInstallment',
                            },
                            {
                              Value: 3.37,
                              NumberOfInstallments: 1,
                              TotalValuePlusInterestRate: 3.37,
                              PaymentSystemName: 'Contra Entrega Efectivo',
                              PaymentSystemGroupName:
                                'custom201PaymentGroupPaymentGroup',
                              __typename: 'CommertialOfferInstallment',
                            },
                            {
                              Value: 3.37,
                              NumberOfInstallments: 1,
                              TotalValuePlusInterestRate: 3.37,
                              PaymentSystemName:
                                'Contra Entrega Tarjeta de Debito',
                              PaymentSystemGroupName:
                                'custom203PaymentGroupPaymentGroup',
                              __typename: 'CommertialOfferInstallment',
                            },
                            {
                              Value: 3.37,
                              NumberOfInstallments: 1,
                              TotalValuePlusInterestRate: 3.37,
                              PaymentSystemName:
                                'Contra Entrega Tarjeta de Credito',
                              PaymentSystemGroupName:
                                'custom204PaymentGroupPaymentGroup',
                              __typename: 'CommertialOfferInstallment',
                            },
                            {
                              Value: 3.37,
                              NumberOfInstallments: 1,
                              TotalValuePlusInterestRate: 3.37,
                              PaymentSystemName: 'Contra Entrega Tarjeta Clave',
                              PaymentSystemGroupName:
                                'custom205PaymentGroupPaymentGroup',
                              __typename: 'CommertialOfferInstallment',
                            },
                          ],
                          AvailableQuantity: 99999,
                          IsAvailable: true,
                          __typename: 'SellerCommertialOffer',
                        },
                        __typename: 'ItemSeller',
                      },
                    ],
                    __typename: 'ProductItem',
                  },
                ],
                __typename: 'ProductDTO',
              },
              {
                productId: '6723',
                productName:
                  'Blanqueador Desinfectante Blancox Flora Vital 1000 ml',
                categories: [
                  '/Limpieza del Hogar y Ropa/Cuidado de la Ropa/Quita manchas y remojantes/',
                  '/Limpieza del Hogar y Ropa/Cuidado de la Ropa/',
                  '/Limpieza del Hogar y Ropa/',
                ],
                productClusters: [
                  ['174', 'Todos los Productos'],
                  ['194', '7% ITBMS'],
                  ['263', 'Limpieza'],
                  ['296', 'TODOS LOS PRODUCTOS'],
                  ['314', '¡Celebra con nosotros nuestro aniversario 34!'],
                ],
                clusterHighlights: [],
                brand: 'Blancox',
                linkText:
                  'blanqueador-desinfectante-blancox-flora-vital-1000-ml-7703812000437',
                skuSpecifications: null,
                items: [
                  {
                    itemId: '6724',
                    name: 'Blanqueador Desinfectante Blancox Flora Vital 1000 ml',
                    nameComplete:
                      'Blanqueador Desinfectante Blancox Flora Vital 1000 ml',
                    variationsValues: [],
                    variations: null,
                    images: [
                      {
                        imageUrl:
                          'https://superxtrapanama.vteximg.com.br/arquivos/ids/161065/7703812000437.png?v=637806428356430000',
                        __typename: 'ItemImage',
                      },
                    ],
                    sellers: [
                      {
                        sellerName: 'Super Xtra',
                        sellerDefault: true,
                        sellerId: '1',
                        commertialOffer: {
                          ListPrice: 2.16,
                          Price: 2.16,
                          Teasers: [],
                          Installments: [
                            {
                              Value: 2.16,
                              NumberOfInstallments: 1,
                              TotalValuePlusInterestRate: 2.16,
                              PaymentSystemName: 'Visa',
                              PaymentSystemGroupName: 'creditCardPaymentGroup',
                              __typename: 'CommertialOfferInstallment',
                            },
                            {
                              Value: 2.16,
                              NumberOfInstallments: 1,
                              TotalValuePlusInterestRate: 2.16,
                              PaymentSystemName: 'Mastercard',
                              PaymentSystemGroupName: 'creditCardPaymentGroup',
                              __typename: 'CommertialOfferInstallment',
                            },
                            {
                              Value: 2.16,
                              NumberOfInstallments: 1,
                              TotalValuePlusInterestRate: 2.16,
                              PaymentSystemName: 'Contra Entrega Efectivo',
                              PaymentSystemGroupName:
                                'custom201PaymentGroupPaymentGroup',
                              __typename: 'CommertialOfferInstallment',
                            },
                            {
                              Value: 2.16,
                              NumberOfInstallments: 1,
                              TotalValuePlusInterestRate: 2.16,
                              PaymentSystemName:
                                'Contra Entrega Tarjeta de Debito',
                              PaymentSystemGroupName:
                                'custom203PaymentGroupPaymentGroup',
                              __typename: 'CommertialOfferInstallment',
                            },
                            {
                              Value: 2.16,
                              NumberOfInstallments: 1,
                              TotalValuePlusInterestRate: 2.16,
                              PaymentSystemName:
                                'Contra Entrega Tarjeta de Credito',
                              PaymentSystemGroupName:
                                'custom204PaymentGroupPaymentGroup',
                              __typename: 'CommertialOfferInstallment',
                            },
                            {
                              Value: 2.16,
                              NumberOfInstallments: 1,
                              TotalValuePlusInterestRate: 2.16,
                              PaymentSystemName: 'Contra Entrega Tarjeta Clave',
                              PaymentSystemGroupName:
                                'custom205PaymentGroupPaymentGroup',
                              __typename: 'CommertialOfferInstallment',
                            },
                          ],
                          AvailableQuantity: 99999,
                          IsAvailable: true,
                          __typename: 'SellerCommertialOffer',
                        },
                        __typename: 'ItemSeller',
                      },
                    ],
                    __typename: 'ProductItem',
                  },
                ],
                __typename: 'ProductDTO',
              },
            ],
            display: {
              slug: 'carrossel-de-produtos',
              __typename: 'ElementDisplay',
            },
            items: [
              {
                id: '1c253078-11aa-4523-b568-ac328ae9a8f3',
                name: 'Leche de coco',
                countdown: false,
                padding: 0,
                filter_data: null,
                schedule_end: null,
                schedule_start: '2024-10-07T22:03:04.272Z',
                redirect_type: null,
                redirect_value: null,
                modal: null,
                has_modal: false,
                text_color: null,
                weight: null,
                width: null,
                facets: null,
                image_description: null,
                highlighted: false,
                image_align: null,
                redirect_data: null,
                highlighted_color: null,
                file: null,
                reference_value: null,
                __typename: 'GroupElement',
              },
              {
                id: 'fd49d94b-2f20-40b2-974c-6fb864790517',
                name: 'Patitas de cerdo',
                countdown: false,
                padding: 0,
                filter_data: null,
                schedule_end: null,
                schedule_start: '2024-10-07T22:04:36.506Z',
                redirect_type: null,
                redirect_value: null,
                modal: null,
                has_modal: false,
                text_color: null,
                weight: null,
                width: null,
                facets: null,
                image_description: null,
                highlighted: false,
                image_align: null,
                redirect_data: null,
                highlighted_color: null,
                file: null,
                reference_value: null,
                __typename: 'GroupElement',
              },
              {
                id: 'fe56963c-30b0-46a1-bb08-b442d73758f3',
                name: 'Pasitas por media libras',
                countdown: false,
                padding: 0,
                filter_data: null,
                schedule_end: null,
                schedule_start: '2024-10-07T22:06:01.258Z',
                redirect_type: null,
                redirect_value: null,
                modal: null,
                has_modal: false,
                text_color: null,
                weight: null,
                width: null,
                facets: null,
                image_description: null,
                highlighted: false,
                image_align: null,
                redirect_data: null,
                highlighted_color: null,
                file: null,
                reference_value: null,
                __typename: 'GroupElement',
              },
              {
                id: 'f865da46-758a-4a6a-b1d0-ddf26a320292',
                name: 'Blanqueador Desinfectante Blancox Flora Vital 1000 ml',
                countdown: false,
                padding: 0,
                filter_data: null,
                schedule_end: null,
                schedule_start: '2024-10-07T22:09:08.712Z',
                redirect_type: null,
                redirect_value: null,
                modal: null,
                has_modal: false,
                text_color: null,
                weight: null,
                width: null,
                facets: null,
                image_description: null,
                highlighted: false,
                image_align: null,
                redirect_data: null,
                highlighted_color: null,
                file: null,
                reference_value: null,
                __typename: 'GroupElement',
              },
            ],
            __typename: 'PageGroup',
          },
          {
            name: 'Novedades PARA TÍ',
            description: null,
            padding: 0,
            vtex_query: null,
            round_shape: false,
            action_text: null,
            redirect_value: null,
            redirect_type: null,
            size: null,
            type: null,
            guidance_type: null,
            is_full_width_banner: null,
            width: null,
            height: null,
            padding_right: 0,
            padding_left: 0,
            padding_top: 0,
            padding_bottom: 0,
            border_color: null,
            border_top: 0,
            border_bottom: 0,
            border_left: 0,
            border_right: 0,
            background_color: null,
            horizontal_padding: 0,
            vertical_padding: 0,
            reference_id: null,
            gap: 2,
            rounded_size: 0,
            product: null,
            products: [],
            display: {
              slug: 'texto-de-foco',
              __typename: 'ElementDisplay',
            },
            items: [],
            __typename: 'PageGroup',
          },
          {
            name: null,
            description: null,
            padding: 0,
            vtex_query: null,
            round_shape: false,
            action_text: null,
            redirect_value: null,
            redirect_type: null,
            size: 'default',
            type: 'horizontal',
            guidance_type: null,
            is_full_width_banner: false,
            width: null,
            height: null,
            padding_right: 0,
            padding_left: 0,
            padding_top: 0,
            padding_bottom: 0,
            border_color: null,
            border_top: 0,
            border_bottom: 0,
            border_left: 0,
            border_right: 0,
            background_color: null,
            horizontal_padding: 0,
            vertical_padding: 0,
            reference_id: null,
            gap: 2,
            rounded_size: 0,
            product: null,
            products: [],
            display: {
              slug: 'carrossel-de-banner',
              __typename: 'ElementDisplay',
            },
            items: [
              {
                id: '6ae1930a-827a-4f21-a366-786e8b1dcb33',
                name: 'Canastra Básica',
                countdown: false,
                padding: 0,
                filter_data: null,
                schedule_end: null,
                schedule_start: '2024-10-03T00:02:00.596Z',
                redirect_type: 'query',
                redirect_value: 'supermercado/despensa?map=c,c',
                modal: null,
                has_modal: false,
                text_color: null,
                weight: null,
                width: null,
                facets: '',
                image_description: '',
                highlighted: false,
                image_align: null,
                redirect_data: null,
                highlighted_color: null,
                file: {
                  url: 'https://d150vhkc2dyuy0.cloudfront.net/superxtra-staging/1727913720074-default--dd6caa93-9961-4a6f-9948-411de4cab07b___1494713b16ae4eed8de5f2471d9a1aa8.gif',
                  __typename: 'Upload',
                },
                reference_value: null,
                __typename: 'GroupElement',
              },
              {
                id: '5d71a55d-6a05-4b85-8ea7-2caa1721f92d',
                name: 'Frutas y Vegetales',
                countdown: false,
                padding: 0,
                filter_data: null,
                schedule_end: null,
                schedule_start: '2024-10-03T00:03:00.738Z',
                redirect_type: 'query',
                redirect_value: 'supermercado/frutas-y-verduras?map=c,c',
                modal: null,
                has_modal: false,
                text_color: null,
                weight: null,
                width: null,
                facets: '',
                image_description: '',
                highlighted: false,
                image_align: null,
                redirect_data: null,
                highlighted_color: null,
                file: {
                  url: 'https://d150vhkc2dyuy0.cloudfront.net/superxtra-staging/1727913780250-default--47bbbeee-7f7f-4995-bb8b-a58c35d13fd1___18208b48ad3f2ab62770eb16c2d6bb41.gif',
                  __typename: 'Upload',
                },
                reference_value: null,
                __typename: 'GroupElement',
              },
              {
                id: '50b25593-226d-40c9-a411-ff29ad9b3cab',
                name: 'Bebidas',
                countdown: false,
                padding: 0,
                filter_data: null,
                schedule_end: null,
                schedule_start: '2024-10-03T00:03:39.846Z',
                redirect_type: 'query',
                redirect_value: 'supermercado/bebidas-y-jugos?map=c,c',
                modal: null,
                has_modal: false,
                text_color: null,
                weight: null,
                width: null,
                facets: '',
                image_description: '',
                highlighted: false,
                image_align: null,
                redirect_data: null,
                highlighted_color: null,
                file: {
                  url: 'https://d150vhkc2dyuy0.cloudfront.net/superxtra-staging/1727913819363-default--32c7306f-666d-4a8b-877f-8e51fc29805a___f048c67803919e3ec5ad9be4e808caf9.gif',
                  __typename: 'Upload',
                },
                reference_value: null,
                __typename: 'GroupElement',
              },
              {
                id: '8033617a-0a68-421a-92cb-db8a62aa25fd',
                name: 'Embutidos',
                countdown: false,
                padding: 0,
                filter_data: null,
                schedule_end: null,
                schedule_start: '2024-10-03T00:04:14.729Z',
                redirect_type: 'query',
                redirect_value: 'supermercado/embutidos?map=c,c',
                modal: null,
                has_modal: false,
                text_color: null,
                weight: null,
                width: null,
                facets: '',
                image_description: '',
                highlighted: false,
                image_align: null,
                redirect_data: null,
                highlighted_color: null,
                file: {
                  url: 'https://d150vhkc2dyuy0.cloudfront.net/superxtra-staging/1727913854258-default--29873c96-d4d7-4a4e-a641-f67212647f4e___0153d2d923f2995899c28c695c1aa746.gif',
                  __typename: 'Upload',
                },
                reference_value: null,
                __typename: 'GroupElement',
              },
            ],
            __typename: 'PageGroup',
          },
          {
            name: 'TUS CATEGORÍAS FAVORITAS',
            description: null,
            padding: 0,
            vtex_query: null,
            round_shape: false,
            action_text: null,
            redirect_value: null,
            redirect_type: null,
            size: null,
            type: null,
            guidance_type: null,
            is_full_width_banner: null,
            width: null,
            height: null,
            padding_right: 0,
            padding_left: 0,
            padding_top: 0,
            padding_bottom: 0,
            border_color: null,
            border_top: 0,
            border_bottom: 0,
            border_left: 0,
            border_right: 0,
            background_color: null,
            horizontal_padding: 0,
            vertical_padding: 0,
            reference_id: null,
            gap: 2,
            rounded_size: 0,
            product: null,
            products: [],
            display: {
              slug: 'texto-de-foco',
              __typename: 'ElementDisplay',
            },
            items: [],
            __typename: 'PageGroup',
          },
          {
            name: 'Carrossel banner 4 ',
            description: null,
            padding: 0,
            vtex_query: null,
            round_shape: false,
            action_text: null,
            redirect_value: null,
            redirect_type: null,
            size: null,
            type: null,
            guidance_type: null,
            is_full_width_banner: null,
            width: null,
            height: null,
            padding_right: 0,
            padding_left: 0,
            padding_top: 0,
            padding_bottom: 0,
            border_color: null,
            border_top: 0,
            border_bottom: 0,
            border_left: 0,
            border_right: 0,
            background_color: null,
            horizontal_padding: 0,
            vertical_padding: 0,
            reference_id: null,
            gap: 2,
            rounded_size: 0,
            product: null,
            products: [],
            display: {
              slug: 'carrossel-de-stories',
              __typename: 'ElementDisplay',
            },
            items: [
              {
                id: '4ac6182c-cee7-4610-be39-d0b646d8700b',
                name: 'Supermercado',
                countdown: false,
                padding: 0,
                filter_data: null,
                schedule_end: null,
                schedule_start: '2024-10-03T00:06:26.510Z',
                redirect_type: 'query',
                redirect_value: 'supermercado?map=c',
                modal: null,
                has_modal: false,
                text_color: null,
                weight: null,
                width: null,
                facets: '',
                image_description: null,
                highlighted: false,
                image_align: null,
                redirect_data: null,
                highlighted_color: null,
                file: {
                  url: 'https://d150vhkc2dyuy0.cloudfront.net/superxtra-staging/1727913986112-default--2c9b8462-e303-46fe-9e8b-1ad8f143c6c4___01f8b3ba2dfb477a1f65c83f833d3bbd.png',
                  __typename: 'Upload',
                },
                reference_value: '',
                __typename: 'GroupElement',
              },
              {
                id: '33044d37-452e-4a92-ac51-a53d50f7be04',
                name: 'Bienestar y salud',
                countdown: false,
                padding: 0,
                filter_data: null,
                schedule_end: null,
                schedule_start: '2024-10-03T00:08:51.245Z',
                redirect_type: 'query',
                redirect_value: 'xtra-farmacia/bienestar-y-salud?map=c,c',
                modal: null,
                has_modal: false,
                text_color: null,
                weight: null,
                width: null,
                facets: '',
                image_description: null,
                highlighted: false,
                image_align: null,
                redirect_data: null,
                highlighted_color: null,
                file: {
                  url: 'https://d150vhkc2dyuy0.cloudfront.net/superxtra-staging/1727914130826-default--b8f5bbc1-b498-4182-8a59-da163590df67___67aef1314cb55596e79aec8913fe8d5b.png',
                  __typename: 'Upload',
                },
                reference_value: '',
                __typename: 'GroupElement',
              },
              {
                id: '1bd3f96c-99ce-4986-a4c6-c9ab258be2b6',
                name: 'Juguetería, Recreación y Deportes',
                countdown: false,
                padding: 0,
                filter_data: null,
                schedule_end: null,
                schedule_start: '2024-10-03T00:09:40.239Z',
                redirect_type: 'query',
                redirect_value: 'jugueteria-recreacion-y-deportes?map=c',
                modal: null,
                has_modal: false,
                text_color: null,
                weight: null,
                width: null,
                facets: '',
                image_description: null,
                highlighted: false,
                image_align: null,
                redirect_data: null,
                highlighted_color: null,
                file: {
                  url: 'https://d150vhkc2dyuy0.cloudfront.net/superxtra-staging/1727914179809-default--05e26aa6-eb62-49dc-9b11-6380a628f6d8___bac30fc27b02f1d7d9f17fcb20240bd7.png',
                  __typename: 'Upload',
                },
                reference_value: '',
                __typename: 'GroupElement',
              },
              {
                id: '3e16fa4a-e4d6-445c-9b16-434708680f9a',
                name: 'Mascotas',
                countdown: false,
                padding: 0,
                filter_data: null,
                schedule_end: null,
                schedule_start: '2024-10-03T00:10:07.111Z',
                redirect_type: 'query',
                redirect_value: 'mascotas?map=c',
                modal: null,
                has_modal: false,
                text_color: null,
                weight: null,
                width: null,
                facets: '',
                image_description: null,
                highlighted: false,
                image_align: null,
                redirect_data: null,
                highlighted_color: null,
                file: {
                  url: 'https://d150vhkc2dyuy0.cloudfront.net/superxtra-staging/1727914206711-default--06a49312-6780-4018-8f27-423bda098056___96080aec320d19f9674f4a487528b7fa.png',
                  __typename: 'Upload',
                },
                reference_value: '',
                __typename: 'GroupElement',
              },
            ],
            __typename: 'PageGroup',
          },
          {
            name: null,
            description: null,
            padding: 0,
            vtex_query: null,
            round_shape: false,
            action_text: null,
            redirect_value: null,
            redirect_type: null,
            size: null,
            type: null,
            guidance_type: null,
            is_full_width_banner: null,
            width: '150',
            height: '120',
            padding_right: 0,
            padding_left: 0,
            padding_top: 0,
            padding_bottom: 0,
            border_color: null,
            border_top: 0,
            border_bottom: 0,
            border_left: 0,
            border_right: 0,
            background_color: null,
            horizontal_padding: 0,
            vertical_padding: 0,
            reference_id: null,
            gap: 2,
            rounded_size: 0,
            product: null,
            products: [],
            display: {
              slug: 'banner-unico',
              __typename: 'ElementDisplay',
            },
            items: [
              {
                id: '2f2aac9b-c6bc-4443-aac6-16aa9bed2c00',
                name: 'Limpieza del Hogar y Ropa',
                countdown: false,
                padding: 0,
                filter_data: null,
                schedule_end: null,
                schedule_start: '2024-10-03T00:12:06.908Z',
                redirect_type: 'query',
                redirect_value: 'limpieza-del-hogar-y-ropa?map=c',
                modal: null,
                has_modal: false,
                text_color: null,
                weight: null,
                width: null,
                facets: '',
                image_description: null,
                highlighted: false,
                image_align: null,
                redirect_data: null,
                highlighted_color: null,
                file: {
                  url: 'https://d150vhkc2dyuy0.cloudfront.net/superxtra-staging/1727914326498-default--cd2c8769-dd76-4c37-b772-8e11cf05496f___b25b67f21932c1903f851cb514fa4f56.png',
                  __typename: 'Upload',
                },
                reference_value: null,
                __typename: 'GroupElement',
              },
            ],
            __typename: 'PageGroup',
          },
        ],
        __typename: 'PageGroupPaginated',
      },
      __typename: 'Page',
    },
  },
};
